import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BehaviorSubject ,  Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthService } from 'app/core/services/auth/auth.service';
import { BaseAuthService } from 'app/core/services/base-auth.service';
import { LivreDuMois } from 'app/livre-du-mois/shared/models/livre-du-mois.model';

@Injectable()
export class LivreDuMoisService extends BaseAuthService {
  private rightColumn$ = new BehaviorSubject<string>(null);
  rightColumn = this.rightColumn$.asObservable();

  constructor(public http: HttpClient, public auth: AuthService) {
    super(http, auth);
  }

  enableRightColumn(newspaper) {
    this.rightColumn$.next(newspaper);
  }

  disableRightColumn() {
    this.rightColumn$.next(null);
  }

  getBooks(parameters: Object): Observable<LivreDuMois[]> {
    return this.get('books', { ...parameters, auth_tokens: true }).pipe(
      map(books => books.map(book => LivreDuMois.fromObject(book)))
    );
  }

  getBook(slug): Observable<LivreDuMois> {
    return this.get('book', { slug, auth_tokens: true }).pipe(map(books => LivreDuMois.fromObject(books[0])));
  }
}
